// 导入所需的模块和类型
import { getBrowserID, getSessionID, getInnerID } from "./du_web_sdk.js";
import DataMgr from "../DataMgr";
import {fwkConst} from "@/Fwk/FwkConst";
import {confJson} from "@/app/config/confJson";
import Util from "@/Master/Util";

/**
 * DuMgr 类用于管理和初始化与 Du 服务相关的 ID 信息
 */
export default class DuMgr {
    // 静态属性定义
    static apikey: string = confJson.sm_apiKey;
    static businessId: string = confJson.sm_businessId;
    static tag: string = "[SM-DuMgr]";

    /**
     * 初始化方法，获取并存储 Browser ID、Inner ID 和 Session ID
     */
    static Init(): void {
        if (Util.isLog) {
            console.log(`${this.tag}`, '初始化方法，获取并存储 Browser ID、Inner ID 和 Session ID');
        }

        // 获取 Browser ID
        getBrowserID(this.apikey, this.businessId, "message", (cbID: string) => {
            if (Util.isLog) {
                console.log(`${this.tag}`, '-browser_id: ' + cbID);
            }
            if (cbID) {
                DataMgr.setStorage(fwkConst.SM_BROWSER_ID, cbID);
            }
        });

        // 获取 Inner ID（SMID）
        getInnerID(this.apikey, this.businessId, "message", (cbID: string) => {
            if (Util.isLog) {
                console.log(`${this.tag}`, '-SMID: ' + cbID);
            }
            if (cbID) {
                DataMgr.setStorage(fwkConst.SM_ID, cbID);
            }
        });

        // 获取 Session ID
        getSessionID(this.apikey, this.businessId, "message", (sessionID: string) => {
            if (Util.isLog) {
                console.log(`${this.tag}`, '-Session: ' + sessionID);
            }
            if (sessionID) {
                DataMgr.setStorage(fwkConst.SM_SESSION_ID, sessionID);
            }
        });

    }

    /**
     * 获取存储的 SMID
     * @returns 存储的 SMID 或空字符串
     */
    static get SMID(): string {
        const smID: string | null = DataMgr.getStorage(fwkConst.SM_ID);
        if (smID) {
            return smID;
        }
        return "";
    }
}
